import type { GeneratedDoorPlacement } from "building-types/doors/doorTypes";
import type { GeneratedWindowPlacement } from "building-types/windows/windowTypes";
import type { PolyLine2 } from "geom/polyLine2Types";
import type { WallCut } from "./wallCutTypes";

export enum WallGapSource {
  WINDOW = "WINDOW",
  DOOR = "DOOR",
  MULTIPLE = "MULTIPLE",
  // to be extended as needed
}

export interface WallGap {
  openings: (GeneratedWindowPlacement | GeneratedDoorPlacement | WallCut)[];
  start: number;
  center: number;
  end: number;
  bottom: number;
  height: number;
  hasStartCasing: boolean;
  hasEndCasing: boolean;
  noMerge?: boolean;
  source?: WallGapSource;
  sourceId?: string;
}

// Wall gaps sorted by their `start` along to the directed `edge`.
export interface StartSortedWallGaps {
  readonly edge: PolyLine2;
  readonly gaps: WallGap[];
}

export interface WallGapDescriptor {
  start: number;
  center: number;
  end: number;
  bottom: number;
  height: number;
  id: string;
}
